import { http } from "../../assets/js/http";

export const getCustomLogo = async () => {
  return http.get('/upload/logo/index.json')
    .then((res) => {
      const { light, dark } = res.data;
      if (!light || !dark) {
        return Promise.reject('bad logo data');
      }
      return { light, dark };
    });
};
